<script setup lang="ts">
import { computed } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'

import { getParticipantTeamSide } from '../utils'

interface Props {
  participant: Participant
}

const props = defineProps<Props>()

// computed
const teamSide = computed(() => getParticipantTeamSide(props.participant))
</script>

<template>
  <div
    class="rounded-lg border"
    :class="{
      'bg-current-team-home-10 border-current-team-home-7 text-current-team-home-5':
        teamSide === 'home',
      'bg-current-team-away-10 border-current-team-away-7 text-current-team-away-5':
        teamSide === 'away',
    }"
  >
    <slot />
  </div>
</template>
